import { useQuery } from "@tanstack/react-query";
import { useLocation } from "@tanstack/react-location";
import { getProposalsSdk } from "../graphql/client/proposals";
export const useQueryAudits = (passedHash) => {
    const { current: { hash }, } = useLocation();
    const thisHash = passedHash ?? hash;
    return useQuery(["governance.getAudits", thisHash], async () => {
        try {
            const { getProposalAudits } = await getProposalsSdk();
            const audits = await getProposalAudits({ proposalHash: thisHash });
            return audits.audits?.length > 0 ? audits.audits : null;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }, {
        suspense: true,
        staleTime: Infinity,
    });
};
//# sourceMappingURL=useQueryAudits.js.map